// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterBlockForm-commonHeaderAdmin-GwBba {
	position: fixed !important;
}

.FooterBlockForm-adminLayout-Kmec8 {
	padding-top: 64px !important;
}

.FooterBlockForm-box-rmjcL h2 {
	font-size: 21px;
	font-weight: 600;
}

.FooterBlockForm-exportLink-LoXWc {
	margin-bottom: -29px;
}

.FooterBlockForm-blockCenter-kCekG {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.FooterBlockForm-panelHeader-kWeoH {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.FooterBlockForm-currencyselect-ZEWDC {
	width: 100%;
	margin-right: 0px;
}

.FooterBlockForm-panelHeader-kWeoH {
	overflow: hidden;
	position: relative;
}

.FooterBlockForm-mar0-oT_Fo {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.FooterBlockForm-blockCenter-kCekG {
		padding: 0px;
	}

	.FooterBlockForm-panelHeader-kWeoH {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.FooterBlockForm-sideAdminPageWrapper-NCz03 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.FooterBlockForm-panelHeader-kWeoH {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.FooterBlockForm-table-qvvbQ {
	display: table;
}

.FooterBlockForm-tableRow-ZZkm2 {
	display: table-row;
}

.FooterBlockForm-tableCell-DBouN {
	display: table-cell;
	float: none;
}

.FooterBlockForm-formGroup-vDawT {
	margin-bottom: 6px;
}

.FooterBlockForm-select-xhi0N {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.FooterBlockForm-noMargin-TnVAq {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.FooterBlockForm-exportLink-LoXWc {
	padding-top: 10px;
	padding-right: 10px;
}

.FooterBlockForm-labelTextNew-EM8jJ {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.FooterBlockForm-displayInline-DQ3nY {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.FooterBlockForm-btnUPdate-dv4OZ {
	display: inline-block;
}

.FooterBlockForm-btnModalDelete-QR_1H {
	display: inline-block;
	margin-left: 15px;
}

.FooterBlockForm-radioBtn-xMQ6g {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.FooterBlockForm-backgroundImg-_9G0I {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.FooterBlockForm-btnUPdate-dv4OZ {
		display: block;
		margin-bottom: 12px;
	}

	.FooterBlockForm-btnModalDelete-QR_1H {
		display: block;
		margin-left: 0px;
	}

	.FooterBlockForm-btnWidth-h1lb4 {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.FooterBlockForm-bannerImageBg-QI6lJ {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.FooterBlockForm-bannerDelete-QKyAB {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.FooterBlockForm-modalRoot-xPS8z {
	padding: 32px;
}

.FooterBlockForm-modalBorderBottom-shL24 {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.FooterBlockForm-logInModalBody-sDTGV {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.FooterBlockForm-exportSection-dJGB9 {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.FooterBlockForm-exportSectionGridSub-HY0c1 {
	grid-template-columns: 50% 49% !important;
}

.FooterBlockForm-exportText-MT5qZ {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.FooterBlockForm-exportLinkImg-t41jc {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.FooterBlockForm-vtrMiddle-GzghL {
	vertical-align: middle;
}

.FooterBlockForm-exportImg-XZNau {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.FooterBlockForm-profileViewlabel-fX_fm {
	display: inline-block;
	width: 38%
}

.FooterBlockForm-profileViewMainContent-aXn4q {
	display: inline-block;
	width: 62%;
}

.FooterBlockForm-profileViewMain-_ghg2 {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.FooterBlockForm-profileViewInner-vXxLv {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.FooterBlockForm-profileImageSection-sv7jp {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.FooterBlockForm-lastviewInner-XnU9d {
	padding: 10px;
}

.FooterBlockForm-whyHostHoriLine-OiSHz {
	margin: 30px 0;
}

.FooterBlockForm-tableGrid-T6dki {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.FooterBlockForm-headingContent-JkiO_ {
	font-size: 18px;
	font-weight: 500;
}

.FooterBlockForm-refundTextColor-Vnn3y {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.FooterBlockForm-dividerLine-B3TDu {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.FooterBlockForm-smallContent-kFOjK {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.FooterBlockForm-sideAdminPageWrapper-NCz03 {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.FooterBlockForm-sideAdminPageWrapper-NCz03 {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.FooterBlockForm-exportSection-dJGB9 {
		grid-template-columns: 100%;
	}

	.FooterBlockForm-exportSectionGridSub-HY0c1 {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.FooterBlockForm-profileViewlabel-fX_fm {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.FooterBlockForm-profileViewMainContent-aXn4q {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.FooterBlockForm-ChangeToUpperCase-WWtU9 {
	text-transform: uppercase
}

.FooterBlockForm-noBorder-TnPXr {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.FooterBlockForm-siteAdminHeading-rAeQJ {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.FooterBlockForm-siteAdminSubHeading-VeqN_ {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.FooterBlockForm-adminFormDivider-kFQdh {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.FooterBlockForm-errorMessage-ghMS1 {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.FooterBlockForm-panelHeader-kWeoH {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.FooterBlockForm-formGroup-vDawT {
  margin-bottom: 6px;
}

.FooterBlockForm-select-xhi0N {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.FooterBlockForm-labelText-Dk1pJ {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.FooterBlockForm-space1-srPte {
	margin-bottom: 6px !important;
}

.FooterBlockForm-space2-FYflK {
	margin-bottom: 12px !important;
}

.FooterBlockForm-space3-yZc7U {
	margin-bottom: 18px !important;
}

.FooterBlockForm-space4-ZhNRz {
	margin-bottom: 24px !important;
}

.FooterBlockForm-space5-efPXY {
	margin-bottom: 30px !important;
}

.FooterBlockForm-space6-vYRKl {
	margin-bottom: 36px !important;
}

.FooterBlockForm-space7-wIbMk {
	margin-bottom: 42px !important;
}

.FooterBlockForm-spaceTop8-koNgN {
	margin-bottom: 48px !important;
}

.FooterBlockForm-spaceTop1-fNAd4 {
	margin-top: 6px !important;
}

.FooterBlockForm-spaceTop2-RrX69 {
	margin-top: 12px !important;
}

.FooterBlockForm-spaceTop3-H0Xva {
	margin-top: 18px !important;
}

.FooterBlockForm-spaceTop4-AuNEI {
	margin-top: 24px !important;
}

.FooterBlockForm-spaceTop5-MvDGg {
	margin-top: 30px !important;
}

.FooterBlockForm-spaceTop6-nGw_z {
	margin-top: 36px !important;
}

.FooterBlockForm-spaceTop7-c18HS {
	margin-top: 42px !important;
}

.FooterBlockForm-spaceTop8-koNgN {
	margin-top: 48px !important;
}

.FooterBlockForm-noMargin-TnVAq {
	margin: 0px !important;
}

.FooterBlockForm-padding1-CpYZs {
	padding-bottom: 6px !important;
}

.FooterBlockForm-padding2-Ql93d {
	padding-bottom: 12px !important;
}

.FooterBlockForm-padding3-g8zKK {
	padding-bottom: 18px !important;
}

.FooterBlockForm-padding4-JwkgW {
	padding-bottom: 24px !important;
}

.FooterBlockForm-padding5-EnkZD {
	padding-bottom: 30px !important;
}

.FooterBlockForm-padding6-XL2wT {
	padding-bottom: 36px !important;
}

.FooterBlockForm-padding7-EXJpw {
	padding-bottom: 42px !important;
}

.FooterBlockForm-paddingTop1-q1OK8 {
	padding-top: 6px !important;
}

.FooterBlockForm-paddingTop2-Lqai0 {
	padding-top: 12px !important;
}

.FooterBlockForm-paddingTop3-jJqEE {
	padding-top: 18px !important;
}

.FooterBlockForm-paddingTop4-xKh_G {
	padding-top: 24px !important;
}

.FooterBlockForm-paddingTop5-LqMv3 {
	padding-top: 30px !important;
}

.FooterBlockForm-paddingTop6-ZfDxC {
	padding-top: 36px !important;
}

.FooterBlockForm-paddingTop7-cB56W {
	padding-top: 42px !important;
}

.FooterBlockForm-noPadding-HHdtk {
	padding: 0px !important;
}

.FooterBlockForm-textBold-mMnt8 {
	font-weight: 500 !important;
}

.FooterBlockForm-textBolder-FDxPJ {
	font-weight: 700 !important;
}

.FooterBlockForm-textNormal-lZpGY {
	font-weight: normal !important;
}

.FooterBlockForm-spaceBottom20-lAbBt {
	margin-bottom: 20px;
}

.FooterBlockForm-spaceBottom10-fLWy9 {
	margin-bottom: 10px;
}

.FooterBlockForm-marginNone-jN67p {
	margin: 0;
}

.FooterBlockForm-spaceBottom15-m1pVJ {
	margin-bottom: 15px;
}

.FooterBlockForm-marginTopNone-vxkjZ {
	margin-top: 0;
}

.FooterBlockForm-spaceTop11-H3jbx {
	margin-top: 11px;
}

.FooterBlockForm-spaceTop21-szBQJ {
	margin-top: 21px;
}

.FooterBlockForm-spaceTop20-Y8g7m {
	margin-top: 20px;
}

.FooterBlockForm-spaceTop10-CEoYP {
	margin-top: 10px;
}

/*New Design Text Colors */

.FooterBlockForm-textDarkBlue-NJTiD {
	color: rgb(20, 39, 94) !important;
}

.FooterBlockForm-textLightBlue-FKrCk {
	color: rgb(57, 87, 106) !important;
}

.FooterBlockForm-textLightSandleGreen-I5PRC {
	color: rgb(76, 86, 41) !important;
}

.FooterBlockForm-textLightBrown-Tjsu4 {
	color: rgb(115, 79, 33) !important;
}

.FooterBlockForm-textMediumMaroon-uM986 {
	color: rgb(87, 37, 51) !important;
}

.FooterBlockForm-textBrown-w0Ugt {
	color: rgb(160, 47, 24) !important;
}

.FooterBlockForm-textMaroon-JHl2X {
	color: rgb(155, 49, 67) !important;
}

.FooterBlockForm-textDarkBrown-TgGQ2 {
	color: rgb(83, 18, 16) !important;
}

.FooterBlockForm-textMediumBrown-NGa54 {
	color: rgb(142, 28, 10) !important;
}

.FooterBlockForm-textSkyBlue-fGXAE {
	color: rgb(37, 117, 141) !important;
}

.FooterBlockForm-textGray-Ni4b9 {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `FooterBlockForm-commonHeaderAdmin-GwBba`,
	"adminLayout": `FooterBlockForm-adminLayout-Kmec8`,
	"box": `FooterBlockForm-box-rmjcL`,
	"exportLink": `FooterBlockForm-exportLink-LoXWc`,
	"blockCenter": `FooterBlockForm-blockCenter-kCekG`,
	"panelHeader": `FooterBlockForm-panelHeader-kWeoH`,
	"currencyselect": `FooterBlockForm-currencyselect-ZEWDC`,
	"mar0": `FooterBlockForm-mar0-oT_Fo`,
	"sideAdminPageWrapper": `FooterBlockForm-sideAdminPageWrapper-NCz03`,
	"table": `FooterBlockForm-table-qvvbQ`,
	"tableRow": `FooterBlockForm-tableRow-ZZkm2`,
	"tableCell": `FooterBlockForm-tableCell-DBouN`,
	"formGroup": `FooterBlockForm-formGroup-vDawT`,
	"select": `FooterBlockForm-select-xhi0N`,
	"noMargin": `FooterBlockForm-noMargin-TnVAq`,
	"labelTextNew": `FooterBlockForm-labelTextNew-EM8jJ`,
	"displayInline": `FooterBlockForm-displayInline-DQ3nY`,
	"btnUPdate": `FooterBlockForm-btnUPdate-dv4OZ`,
	"btnModalDelete": `FooterBlockForm-btnModalDelete-QR_1H`,
	"radioBtn": `FooterBlockForm-radioBtn-xMQ6g`,
	"backgroundImg": `FooterBlockForm-backgroundImg-_9G0I`,
	"btnWidth": `FooterBlockForm-btnWidth-h1lb4`,
	"bannerImageBg": `FooterBlockForm-bannerImageBg-QI6lJ`,
	"bannerDelete": `FooterBlockForm-bannerDelete-QKyAB`,
	"modalRoot": `FooterBlockForm-modalRoot-xPS8z`,
	"modalBorderBottom": `FooterBlockForm-modalBorderBottom-shL24`,
	"logInModalBody": `FooterBlockForm-logInModalBody-sDTGV`,
	"exportSection": `FooterBlockForm-exportSection-dJGB9`,
	"exportSectionGridSub": `FooterBlockForm-exportSectionGridSub-HY0c1`,
	"exportText": `FooterBlockForm-exportText-MT5qZ`,
	"exportLinkImg": `FooterBlockForm-exportLinkImg-t41jc`,
	"vtrMiddle": `FooterBlockForm-vtrMiddle-GzghL`,
	"exportImg": `FooterBlockForm-exportImg-XZNau`,
	"profileViewlabel": `FooterBlockForm-profileViewlabel-fX_fm`,
	"profileViewMainContent": `FooterBlockForm-profileViewMainContent-aXn4q`,
	"profileViewMain": `FooterBlockForm-profileViewMain-_ghg2`,
	"profileViewInner": `FooterBlockForm-profileViewInner-vXxLv`,
	"profileImageSection": `FooterBlockForm-profileImageSection-sv7jp`,
	"lastviewInner": `FooterBlockForm-lastviewInner-XnU9d`,
	"whyHostHoriLine": `FooterBlockForm-whyHostHoriLine-OiSHz`,
	"tableGrid": `FooterBlockForm-tableGrid-T6dki`,
	"headingContent": `FooterBlockForm-headingContent-JkiO_`,
	"refundTextColor": `FooterBlockForm-refundTextColor-Vnn3y`,
	"dividerLine": `FooterBlockForm-dividerLine-B3TDu`,
	"smallContent": `FooterBlockForm-smallContent-kFOjK`,
	"ChangeToUpperCase": `FooterBlockForm-ChangeToUpperCase-WWtU9`,
	"noBorder": `FooterBlockForm-noBorder-TnPXr`,
	"siteAdminHeading": `FooterBlockForm-siteAdminHeading-rAeQJ`,
	"siteAdminSubHeading": `FooterBlockForm-siteAdminSubHeading-VeqN_`,
	"adminFormDivider": `FooterBlockForm-adminFormDivider-kFQdh`,
	"errorMessage": `FooterBlockForm-errorMessage-ghMS1`,
	"labelText": `FooterBlockForm-labelText-Dk1pJ`,
	"space1": `FooterBlockForm-space1-srPte`,
	"space2": `FooterBlockForm-space2-FYflK`,
	"space3": `FooterBlockForm-space3-yZc7U`,
	"space4": `FooterBlockForm-space4-ZhNRz`,
	"space5": `FooterBlockForm-space5-efPXY`,
	"space6": `FooterBlockForm-space6-vYRKl`,
	"space7": `FooterBlockForm-space7-wIbMk`,
	"spaceTop8": `FooterBlockForm-spaceTop8-koNgN`,
	"spaceTop1": `FooterBlockForm-spaceTop1-fNAd4`,
	"spaceTop2": `FooterBlockForm-spaceTop2-RrX69`,
	"spaceTop3": `FooterBlockForm-spaceTop3-H0Xva`,
	"spaceTop4": `FooterBlockForm-spaceTop4-AuNEI`,
	"spaceTop5": `FooterBlockForm-spaceTop5-MvDGg`,
	"spaceTop6": `FooterBlockForm-spaceTop6-nGw_z`,
	"spaceTop7": `FooterBlockForm-spaceTop7-c18HS`,
	"padding1": `FooterBlockForm-padding1-CpYZs`,
	"padding2": `FooterBlockForm-padding2-Ql93d`,
	"padding3": `FooterBlockForm-padding3-g8zKK`,
	"padding4": `FooterBlockForm-padding4-JwkgW`,
	"padding5": `FooterBlockForm-padding5-EnkZD`,
	"padding6": `FooterBlockForm-padding6-XL2wT`,
	"padding7": `FooterBlockForm-padding7-EXJpw`,
	"paddingTop1": `FooterBlockForm-paddingTop1-q1OK8`,
	"paddingTop2": `FooterBlockForm-paddingTop2-Lqai0`,
	"paddingTop3": `FooterBlockForm-paddingTop3-jJqEE`,
	"paddingTop4": `FooterBlockForm-paddingTop4-xKh_G`,
	"paddingTop5": `FooterBlockForm-paddingTop5-LqMv3`,
	"paddingTop6": `FooterBlockForm-paddingTop6-ZfDxC`,
	"paddingTop7": `FooterBlockForm-paddingTop7-cB56W`,
	"noPadding": `FooterBlockForm-noPadding-HHdtk`,
	"textBold": `FooterBlockForm-textBold-mMnt8`,
	"textBolder": `FooterBlockForm-textBolder-FDxPJ`,
	"textNormal": `FooterBlockForm-textNormal-lZpGY`,
	"spaceBottom20": `FooterBlockForm-spaceBottom20-lAbBt`,
	"spaceBottom10": `FooterBlockForm-spaceBottom10-fLWy9`,
	"marginNone": `FooterBlockForm-marginNone-jN67p`,
	"spaceBottom15": `FooterBlockForm-spaceBottom15-m1pVJ`,
	"marginTopNone": `FooterBlockForm-marginTopNone-vxkjZ`,
	"spaceTop11": `FooterBlockForm-spaceTop11-H3jbx`,
	"spaceTop21": `FooterBlockForm-spaceTop21-szBQJ`,
	"spaceTop20": `FooterBlockForm-spaceTop20-Y8g7m`,
	"spaceTop10": `FooterBlockForm-spaceTop10-CEoYP`,
	"textDarkBlue": `FooterBlockForm-textDarkBlue-NJTiD`,
	"textLightBlue": `FooterBlockForm-textLightBlue-FKrCk`,
	"textLightSandleGreen": `FooterBlockForm-textLightSandleGreen-I5PRC`,
	"textLightBrown": `FooterBlockForm-textLightBrown-Tjsu4`,
	"textMediumMaroon": `FooterBlockForm-textMediumMaroon-uM986`,
	"textBrown": `FooterBlockForm-textBrown-w0Ugt`,
	"textMaroon": `FooterBlockForm-textMaroon-JHl2X`,
	"textDarkBrown": `FooterBlockForm-textDarkBrown-TgGQ2`,
	"textMediumBrown": `FooterBlockForm-textMediumBrown-NGa54`,
	"textSkyBlue": `FooterBlockForm-textSkyBlue-fGXAE`,
	"textGray": `FooterBlockForm-textGray-Ni4b9`
};
module.exports = ___CSS_LOADER_EXPORT___;
